import commonTranslations from 'common-translations/src/vtj/i18next'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import fp from 'lodash/fp'

const validValues = fp.values(LanguageCode)

export default function translateLanguage({
  code,
  lang,
  shortVersion = false,
}) {
  if (!fp.includes(code)(validValues)) {
    throw new Error(getErrorMessage({ code, shortVersion }))
  }

  const translate = commonTranslations.getFixedT(lang)
  const key = getTranslationKey({ code, lang, shortVersion })
  return translate(key)
}

const getTranslationKey = ({ code, lang, shortVersion }) => {
  const prefix = shortVersion ? 'Short' : 'Long'
  const postfix = fp.capitalize(code)
  return `${prefix}LanguageName${postfix}`
}

const getErrorMessage = ({ code, shortVersion }) => {
  const type = shortVersion ? 'short' : 'long'
  return [
    `Getting translation key for (${type}) language name failed.`,
    `Language '${code}' is not available.`,
    `Supported values are '${validValues.join(`', '`)}'.`,
  ].join(' ')
}
